/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Offcanvas,
  Carousel,
  Image,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import SearchBoxHeader from "./SearchBoxHeader";
import { logout } from "../actions/userActions";
import { useNavigate } from "react-router-dom";

import Categories from "../components/Categories";
import GoogleTranslateComponent from "../components/GoogleTranslateComponent";

function Header() {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const [isLargeScreen, setIsLargeScreen] = useState(true);
  const [isFixed, setIsFixed] = useState(false);

  const checkScreenSize = () => {
    setIsLargeScreen(window.innerWidth >= 768);
  };

  useEffect(() => {
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 4 * 16 /* Assuming 1rem = 16px */) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", checkScreenSize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <header
      style={{
        // fontFamily: "rocko",
        // background: "black",
        height: "6rem",
      }}
    >
      {/* <Navbar
        fixed="top"
        style={{
          top: isFixed ? "-rem" : "0rem", // Adjust the top position values
          transition: "top 0.3s ease-in-out", // Add transition effect
        }}
        // className="bg-oblue-gradient w-100 py-2 text-capitalize d-flex flex-wrap   "

        className={`p-0 bg-oblue-gradient  ${
          isFixed ? "navbar-fixed" : "navbar-scroll"
        }`}
      > */}
      <Navbar
        fixed="top"
        variant="dark"
        collapseOnSelect
        className={`p-0 bg-oblue-gradient w-100 py-2 text-capitalize d-flex flex-wrap  ${
          isFixed ? "navbar-fixed" : "navbar-scroll"
        }`}
        style={{
          top: isFixed ? "-2rem" : "0rem", // Adjust the top position values
          transition: "top 0.3s ease-in-out", // Add transition effect
        }}
      >
        <Container className="d-flex  ">
          <Carousel
            prevIcon
            nextIcon
            indicators={false}
            interval={2000}
            pause="hover"
            className="py-0 my-0 "
          >
            <Carousel.Item key="visit">
              <p className="text-white fs-6 ">
                Visit our showroom in abc address 00
              </p>
            </Carousel.Item>{" "}
            <Carousel.Item key="oticnamefull">
              <p className="text-white fs-6">abc bussiness group</p>
            </Carousel.Item>
            <Carousel.Item key="scurePlatform">
              <p className="text-white fs-6">A secure OnlineShoping Platform</p>
            </Carousel.Item>
            <Carousel.Item key="contact">
              <a href="/" className="text-white text-center fs-6 ">
                Contact Us
              </a>
            </Carousel.Item>
            <Carousel.Item key="phoneNum">
              <p className="text-capitalize fs-6">
                call Us: +2519-123-456-78 &nbsp;&nbsp;
              </p>
            </Carousel.Item>
            <Carousel.Item key="ig">
              <a href="https://instagram.com">
                <span className="fa-brands fa-instagram  text-white fs-4">
                  &nbsp;&nbsp;&nbsp;
                </span>
              </a>
              <a href="https://fb.com">
                {" "}
                <span className="fa-brands fa-facebook text-white  text-white fs-4">
                  &nbsp;&nbsp;&nbsp;
                </span>
              </a>
              <a href="https://telegram.com">
                <span className="fa-brands fa-telegram  text-white fs-4">
                  &nbsp;&nbsp;&nbsp;
                </span>
              </a>
              <a href="https://youtube.com">
                <span className="fa-brands fa-youtube  text-white fs-4">
                  &nbsp;&nbsp;&nbsp;
                </span>
              </a>
            </Carousel.Item>
          </Carousel>
        </Container>
      </Navbar>

      <Container className=" p-0   ">
        {["md"].map((expand) => (
          <Navbar
            fixed="top"
            variant="dark"
            collapseOnSelect
            key={expand}
            expand={expand}
            className={`p-0 bg-oblue-gradient ${
              isFixed ? "navbar-fixed" : "navbar-scroll"
            }`}
            style={{
              top: isFixed ? "0rem" : "2rem", // Adjust the top position values
              transition: "top 0.3s ease-in-out", // Add transition effect
            }}
          >
            <Container>
              <LinkContainer
                className="border  p-1  bg-body-secondary  p-0 rounded-circle"
                to="/"
              >
                <Navbar.Brand className="p-0 m-0  ">
                  <Image
                    style={{ height: "40px", width: "40px" }}
                    src="../../../static/images/favicon.png"
                    alt="f"
                  />
                </Navbar.Brand>
              </LinkContainer>
              {!isLargeScreen && (
                <LinkContainer to="/">
                  <Nav.Link>
                    <span
                      style={{ fontSize: 16 }}
                      className="fas fa-home d-md-none text-white mx-auto ms-2 "
                    ></span>
                    <p className="text-center text-white text-capitalize fs-6 m-0 p-0">
                      home
                    </p>
                  </Nav.Link>
                </LinkContainer>
              )}

              {!isLargeScreen && (
                <div className="  text-white ms-2  ">
                  <div className="ms-3">
                    <Categories />
                  </div>

                  <p className="text-center text-capitalize fs-6 m-0 p-0">
                    Products
                  </p>
                </div>
              )}
              {!isLargeScreen && (
                <LinkContainer to="/contacts">
                  <Nav.Link>
                    <span
                      style={{ fontSize: 16 }}
                      className="fa-solid fa-circle-question d-md-none text-white mx-auto ms-2  "
                    ></span>
                    <p className="text-center text-white text-capitalize fs-6 m-0 p-0">
                      About
                    </p>
                  </Nav.Link>
                </LinkContainer>
              )}
              {!isLargeScreen && (
                <LinkContainer to="/cart">
                  <Nav.Link className="cart">
                    <span
                      style={{ fontSize: 16 }}
                      className="fas fa-shopping-cart  d-md-none text-white ms-1 "
                    ></span>

                    <span className=" d-md-none">
                      {cartItems.reduce((acc, item) => acc + item.qty * 1, 0)}
                    </span>
                    <p className="text-center text-white text-capitalize fs-6 m-0 p-0">
                      Cart
                    </p>
                  </Nav.Link>
                </LinkContainer>
              )}

              <Navbar.Toggle
                className="rounded-3 my-3 py-0 mx-0 px-0 align-self-end  "
                aria-controls={`offcanvasNavbar-expand-${expand}`}
              />
              <Navbar.Offcanvas
                className="bg-oblue  "
                style={{
                  width: "60%",
                  fontsize: 40,
                  background: "#2e3158",
                  // backdropFilter: "blur(6px)",
                  paddingTop: "4px",
                  paddingLeft: "4px",
                  color: "white",
                  fontWeight: 900,
                }}
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton className=" my-0 py-3">
                  OTICSHOP
                </Offcanvas.Header>

                <Nav>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <SearchBoxHeader />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Nav className="ml-auto fs-6  text-capitalize  ">
                    <LinkContainer to="/">
                      <Nav.Link className="d-flex justify-content-start ">
                        <span
                          style={{ fontSize: 16 }}
                          className="fas fa-home  "
                        ></span>
                        <span>&nbsp;Home</span>
                      </Nav.Link>
                    </LinkContainer>
                    {isLargeScreen && <Categories />}
                    {/* <div className="hide-on-small ">
											<Categories />
										</div> */}
                    <LinkContainer to="/contacts">
                      <Nav.Link className="d-flex justify-content-start ">
                        <span
                          style={{ fontSize: 16 }}
                          className="fa-solid fa-circle-question  "
                        ></span>
                        <span className="  ">
                          {" "}
                          &nbsp;About&nbsp;&nbsp;&nbsp;
                        </span>
                      </Nav.Link>
                    </LinkContainer>
                  </Nav>
                  <Nav className="m-auto px-lg-2 "></Nav>
                  <Nav className="ml-auto fs-6">
                    <LinkContainer to="/cart">
                      <Nav.Link className="cart text-nowrap  text-capitalize  ">
                        <span
                          style={{ fontSize: 16 }}
                          className="fas fa-shopping-cart "
                        ></span>

                        <span className=" ">
                          {cartItems.reduce(
                            (acc, item) => acc + item.qty * 1,
                            0
                          )}
                        </span>
                        <span>&nbsp;Cart</span>
                      </Nav.Link>
                    </LinkContainer>
                    {userInfo ? (
                      <NavDropdown
                        title={
                          <span
                            style={{ fontSize: 12 }}
                            className=" text-capitalize "
                          >
                            {userInfo.name}
                          </span>
                        }
                        id="username"
                      >
                        <LinkContainer to="/profile">
                          <NavDropdown.Item>Profile</NavDropdown.Item>
                        </LinkContainer>

                        <NavDropdown.Item onClick={logoutHandler}>
                          Logout
                        </NavDropdown.Item>
                      </NavDropdown>
                    ) : (
                      <LinkContainer to="/login">
                        <Nav.Link className="d-flex justify-content-start text-capitalize  ">
                          <span
                            style={{ fontSize: 15 }}
                            className="fas fa-user"
                          ></span>
                          <span>&nbsp;&nbsp;login</span>
                        </Nav.Link>
                      </LinkContainer>
                    )}

                    {userInfo && userInfo.isAdmin && (
                      <NavDropdown
                        title={
                          <span style={{ fontSize: 11 }} className="">
                            Admin
                          </span>
                        }
                        id="adminmenue"
                      >
                        <LinkContainer to="/admin/userlist">
                          <NavDropdown.Item>Users</NavDropdown.Item>
                        </LinkContainer>

                        <LinkContainer to="/admin/productlist">
                          <NavDropdown.Item>Products</NavDropdown.Item>
                        </LinkContainer>

                        <LinkContainer to="/admin/orderlist">
                          <NavDropdown.Item>Orders</NavDropdown.Item>
                        </LinkContainer>
                      </NavDropdown>
                    )}
                  </Nav>
                  <GoogleTranslateComponent />
                </Nav>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
        {/* <Categories /> */}
      </Container>
    </header>
  );
}

export default Header;
